import React, { useEffect, useState } from 'react';

const getRemaining = () => {
  if (!window.rateLimitUntil) return 0;
  return Math.max(0, window.rateLimitUntil - Date.now());
};

const RateLimitBanner = () => {
  const [remainingMs, setRemainingMs] = useState(getRemaining());

  useEffect(() => {
    const id = setInterval(() => {
      const left = getRemaining();
      setRemainingMs(left);
      if (left <= 0) {
        clearInterval(id);
      }
    }, 1000);
    return () => clearInterval(id);
  }, [window.rateLimitUntil]);

  if (remainingMs <= 0) return null;
  const seconds = Math.ceil(remainingMs / 1000);
  return (
    <div className="rate-limit-banner" data-testid="rate-limit-banner">
      Too many unauthorized attempts. Please wait {seconds}s before retrying.
    </div>
  );
};

export default RateLimitBanner;

